/**
 * Maps between certificate type formats:
 * - DB/GraphQL enum: SCREAMING_SNAKE_CASE (e.g. "HALAL", "PHYTOSANITARY")
 * - DynamoDB OCA permissions: Display label (e.g. "Halal", "Phytosanitary")
 *
 * The indexed Typesense field `certificate_type` stores the display label
 * to match the format used in OCA user permissions (DynamoDB).
 */

/** Map from DB enum (SCREAMING_SNAKE_CASE) to display label (matches DynamoDB OCA permissions) */
const enumToLabel: Record<string, string> = {
  FREE_SALE: "Free sale",
  FREE_SALE_STATEMENT: "Free sale statement",
  LIVE_ANIMALS: "Live animals",
  ORGANICS: "Organics",
  EXPORT_ELIGIBILITY_STATEMENT: "Export eligibility statement",
  SUPPLEMENTARY: "SUPPLEMENTARY",
  SANITARY: "Sanitary",
  HALAL: "Halal",
  CATCH: "Catch",
  PHYTOSANITARY: "Phytosanitary",
  REEXPORT_PHYTOSANITARY: "Reexport phytosanitary",
  OECD_SEED_VARIETAL: "Oecd seed varietal",
  NONCONSIGNMENT: "Nonconsignment",
  PRODUCT_ESTABLISHMENT_REGISTRATION_DOCUMENT:
    "Product establishment registration document",
  OTHER_DOCUMENT: "Other document",
}

/** Map from display label to DB enum (reverse lookup) */
const labelToEnum: Record<string, string> = Object.fromEntries(
  Object.entries(enumToLabel).map(([k, v]) => [v, k]),
)

/**
 * Convert a DB certificate_type enum value to the display label
 * used in DynamoDB OCA permissions and Typesense index.
 */
export const certificateTypeToLabel = (
  dbEnum: string | null,
): string | null => {
  if (!dbEnum) return null
  return enumToLabel[dbEnum] ?? dbEnum
}

/**
 * Convert a display label to the DB certificate_type enum value.
 */
export const labelToCertificateType = (label: string | null): string | null => {
  if (!label) return null
  return labelToEnum[label] ?? label
}
